import { render, staticRenderFns } from "./tableGroup.vue?vue&type=template&id=b9241cda&scoped=true"
import script from "./tableGroup.vue?vue&type=script&lang=js"
export * from "./tableGroup.vue?vue&type=script&lang=js"
import style0 from "./tableGroup.vue?vue&type=style&index=0&id=b9241cda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9241cda",
  null
  
)

export default component.exports